import { X as CloseIcon, SearchIcon } from 'lucide-react';
import React from 'react';

import { useSearchBox } from 'react-instantsearch';
import { Button, Flex, Input } from 'theme-ui';

interface SearchBoxProps {
  onClose: () => void;
  onChange: (value: string) => void;
  hasFocus?: boolean;
}

const SearchBox = ({ onChange, onClose, hasFocus }: SearchBoxProps) => {
  const { query, refine } = useSearchBox();

  return (
    <form>
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          color: 'textSubtle',
        }}
      >
        <SearchIcon
          size={22}
          style={{ marginRight: 8, color: 'currentColor' }}
        />
        <Input
          autoFocus={hasFocus}
          sx={{
            flex: 1,
            fontSize: 3,
            border: 'none',
            outline: 'none',
            bg: 'transparent',
            color: 'text',
            '::placeholder': { color: 'muted' },
          }}
          type="text"
          placeholder="Buscar"
          aria-label="Search"
          onChange={(e) => {
            refine(e.target.value);
            onChange(e.target.value);
          }}
          value={query}
        />
        <Button
          variant="icon"
          onClick={onClose}
          sx={{
            ml: 2,
            color: 'text',
            bg: 'transparent',
            '&:hover': { color: 'primary', bg: 'muted' },
          }}
          aria-label="Cancel"
        >
          <CloseIcon size={22} />
        </Button>
      </Flex>
    </form>
  );
};

export default SearchBox;
